import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" foo? ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ag_header, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_ag_content, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.codeString) + " ", 1),
          _createVNode(_component_ag_text, {
            innerHTML: _ctx.$filters.newLineToBr(_ctx.msgString)
          }, null, 8, ["innerHTML"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}